'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = require('immutable');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactUtils = require('react-utils');

var _hubspot = require('hubspot.PortalIdParser');

var _hubspot2 = _interopRequireDefault(_hubspot);

var _RoleTypes = require('conversations-schema/constants/RoleTypes');

var _RoleTypes2 = _interopRequireDefault(_RoleTypes);

var _ColoringRecord = require('conversations-schema/records/ColoringRecord');

var _ColoringRecord2 = _interopRequireDefault(_ColoringRecord);

var _ChatBubble = require('ui-addon-conversations/components/ChatBubble');

var _ChatBubble2 = _interopRequireDefault(_ChatBubble);

var _MessageFooter = require('ui-addon-conversations/components/MessageFooter');

var _MessageFooter2 = _interopRequireDefault(_MessageFooter);

var _UIAvatar = require('UIComponents/avatar/UIAvatar');

var _UIAvatar2 = _interopRequireDefault(_UIAvatar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var portalId = _hubspot2.default.get();

exports.default = _react2.default.createClass({
  displayName: 'ChatMessage',

  propTypes: {
    message: _react.PropTypes.object.isRequired,
    allMessages: _react.PropTypes.instanceOf(_immutable.List).isRequired,
    publishMessage: _react.PropTypes.func,
    republishMessage: _react.PropTypes.func,
    responder: _react.PropTypes.instanceOf(_immutable.Record),
    messageRole: _react.PropTypes.oneOf(Object.keys(_RoleTypes2.default)).isRequired,
    currentRole: _react.PropTypes.oneOf(Object.keys(_RoleTypes2.default)).isRequired,
    isFirstInGroup: _react.PropTypes.bool,
    isLastInGroup: _react.PropTypes.bool,
    coloring: _react.PropTypes.instanceOf(_ColoringRecord2.default).isRequired,
    readOnly: _react.PropTypes.bool.isRequired
  },

  isSelfText: function isSelfText() {
    var _props = this.props,
        messageRole = _props.messageRole,
        currentRole = _props.currentRole;

    return messageRole === currentRole;
  },
  renderAvatar: function renderAvatar() {
    var responder = this.props.responder;
    var _props2 = this.props,
        currentRole = _props2.currentRole,
        messageRole = _props2.messageRole,
        isLastInGroup = _props2.isLastInGroup;


    var isWidget = currentRole === _RoleTypes2.default.VISITOR;
    var isAgentInVisitorUi = isWidget && messageRole === _RoleTypes2.default.REP;

    if (!isAgentInVisitorUi) {
      return null;
    }

    if (!isLastInGroup) {
      return _react2.default.createElement('div', { className: 'p-x-3' });
    }

    var src = responder ? responder.avatar : undefined;
    var email = responder ? responder.email : undefined;

    return _react2.default.createElement(_UIAvatar2.default, {
      className: 'chat-message-avatar',
      size: 'extra-small',
      src: src,
      email: email,
      portalId: portalId
    });
  },
  renderContent: function renderContent() {
    var _props3 = this.props,
        coloring = _props3.coloring,
        message = _props3.message,
        messageRole = _props3.messageRole,
        currentRole = _props3.currentRole,
        isFirstInGroup = _props3.isFirstInGroup,
        isLastInGroup = _props3.isLastInGroup;


    var className = (0, _reactUtils.classNames)('chat-message-content', {
      'justify-end': this.isSelfText(),
      'justify-start': !this.isSelfText()
    });

    return _react2.default.createElement(
      'div',
      { className: className },
      _react2.default.createElement(_ChatBubble2.default, {
        coloring: coloring,
        message: message,
        messageRole: messageRole,
        currentRole: currentRole,
        isFirstInGroup: isFirstInGroup,
        isLastInGroup: isLastInGroup
      })
    );
  },
  renderMessageFooter: function renderMessageFooter() {
    var _props4 = this.props,
        messageRole = _props4.messageRole,
        currentRole = _props4.currentRole,
        isLastInGroup = _props4.isLastInGroup,
        message = _props4.message,
        allMessages = _props4.allMessages,
        coloring = _props4.coloring,
        publishMessage = _props4.publishMessage,
        republishMessage = _props4.republishMessage,
        readOnly = _props4.readOnly,
        responder = _props4.responder;


    return _react2.default.createElement(_MessageFooter2.default, {
      messageRole: messageRole,
      currentRole: currentRole,
      isLastInGroup: isLastInGroup,
      message: message,
      allMessages: allMessages,
      coloring: coloring,
      publishMessage: publishMessage,
      republishMessage: republishMessage,
      readOnly: readOnly,
      responder: responder
    });
  },
  render: function render() {
    var className = (0, _reactUtils.classNames)('chat-message m-top-1', {
      sender: this.isSelfText(),
      recipient: !this.isSelfText()
    });

    return _react2.default.createElement(
      'div',
      { className: className },
      _react2.default.createElement(
        'div',
        { style: { width: '100%' } },
        this.renderContent(),
        this.renderMessageFooter()
      ),
      this.renderAvatar()
    );
  }
});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-conversations/static-1.133/js/components/ChatMessage.js
// module id = 398
// module chunks = 0 1